import React, { useEffect, useState } from 'react';

export default function DeliverToModal({
  open,
  onClose,
  onConfirm,
  countries,
  countriesLoading,
  countryCode: initialCode,
  postal: initialPostal
}) {
  const [countryCode, setCountryCode] = useState(initialCode || 'IN');
  const [postal, setPostal] = useState(initialPostal || '');

  useEffect(() => {
    if (open) {
      setCountryCode(initialCode || 'IN');
      setPostal(initialPostal || '');
    }
  }, [open, initialCode, initialPostal]);

  if (!open) return null;

  const selected = countries.find((c) => c.code === countryCode) || countries[0];
  const flagSrc = selected?.flag;

  return (
    <div className="mset-dim" role="presentation" onClick={onClose}>
      <div
        className="mset-deliver-sheet"
        role="dialog"
        aria-modal="true"
        aria-label="Deliver to"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mset-deliver-hdr">
          <span className="mset-deliver-title">Deliver to</span>
          <button type="button" className="mset-deliver-x" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <p className="mset-deliver-hint">
          Confirm your location for more accurate shipping estimates and wider range of logistics services
        </p>
        <label className="mset-deliver-lab">Country/region</label>
        <div className="mset-deliver-dd-wrap">
          {flagSrc && <img className="mset-deliver-flag" src={flagSrc} alt="" />}
          <select
            className="mset-deliver-select"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            disabled={countriesLoading}
          >
            {countries.map((c) => (
              <option key={c.id || c.code} value={c.code}>
                {c.name} ({c.code})
              </option>
            ))}
          </select>
        </div>
        <label className="mset-deliver-lab">Postal code (optional)</label>
        <input
          className="mset-deliver-input"
          value={postal}
          onChange={(e) => setPostal(e.target.value)}
          placeholder=" "
          maxLength={32}
          autoComplete="postal-code"
        />
        <button
          type="button"
          className="mset-deliver-confirm"
          onClick={() => onConfirm({ countryCode, postal: postal.trim() || '' })}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}
